<!--
*  TTTech nerve-ui-components
*  Copyright(c) 2022. TTTech Industrial Automation AG.
*
*  ALL RIGHTS RESERVED.
*
*  Usage of this software, including source code, netlists, documentation,
*  is subject to restrictions and conditions of the applicable license
*  agreement with TTTech Industrial Automation AG or its affiliates.
*
*  All trademarks used are the property of their respective owners.
*
*  TTTech Industrial Automation AG and its affiliates do not assume any liability
*  arising out of the application or use of any product described or shown
*  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
*  make changes, at any time, in order to improve reliability, function or
*  design.
*
*  Contact Information:
*  support@tttech-industrial.com
*
*  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
*
* -->
<template>
  <v-col class="pl-0 mt-4">
    <span id="iiotNetworkPropertiesTitle" class="font-18">
      {{ $t('nodes.deployedWorkloadControl.networksPropertiesDialog.title') }}
    </span>
    <div v-if="vmStatus !== 'stopped' && vmStatus !== 'starting'">
      <the-nerve-table
        :columns="columns"
        :empty-state="$t('nodes.deployedWorkloadControl.networksPropertiesDialog.emptyState')"
        :store-module="storeModule"
        :is-action-menu-enabled="false"
        :custom-fetch-action="customFetchAction"
        :custom-count-getter="customCountGetter"
        :custom-list-getter="customListGetter"
        :params="params"
        :is-search-enabled="false"
        :disable-pagination="true"
        :hide-footer="true"
        class="ml-n2 pt-3"
        @params-changed="(params) => changedNetworkParams(params)"
      />
    </div>

    <v-row v-show="errorMessage" class="ml-0 mt-2">
      <span> {{ errorMessage }} </span>
    </v-row>
    <v-row v-if="vmStatus === 'stopped' || vmStatus === 'starting'" class="ml-0 mt-2">
      <div class="text--disabled">
        {{ $t('nodes.deployedWorkloadControl.networkPropertiesMessages') }}
      </div>
    </v-row>
  </v-col>
</template>

<script>
import TheNerveTable from './TheNerveTable.vue';

export default {
  name: 'NetworkProperties',
  components: {
    TheNerveTable,
  },
  props: {
    storeModule: {
      type: String,
      default: '',
    },
    customFetchAction: {
      type: String,
      default: '',
    },
    customCountGetter: {
      type: String,
      default: '',
    },
    customListGetter: {
      type: String,
      default: '',
    },
    params: {
      type: Object,
      default: () => {},
    },
    errorMessage: {
      type: String,
      default: '',
    },
    vmStatus: {
      type: String,
      default: '',
    },
  },
  computed: {
    columns() {
      return [
        {
          text: this.$t('nodes.deployedWorkloadControl.networksPropertiesDialog.interfaceName'),
          value: 'interfaceName',
          sortable: false,
        },
        {
          text: this.$t('nodes.deployedWorkloadControl.networksPropertiesDialog.source'),
          value: 'source',
          sortable: false,
        },
        {
          text: this.$t('nodes.deployedWorkloadControl.networksPropertiesDialog.macAddress'),
          value: 'macAddress',
          sortable: false,
        },
        {
          text: this.$t('nodes.deployedWorkloadControl.networksPropertiesDialog.ipAddress'),
          value: 'ipAddress',
          sortable: false,
        },
        {
          text: this.$t('nodes.deployedWorkloadControl.networksPropertiesDialog.receivedBytes'),
          value: 'receivedBytes',
          sortable: false,
        },
        {
          text: this.$t('nodes.deployedWorkloadControl.networksPropertiesDialog.transmittedBytes'),
          value: 'transmittedBytes',
          info: this.$t('nodes.deployedWorkloadControl.networksPropertiesDialog.transmittedBytesTooltip'),
          sortable: false,
        },
      ];
    },
  },
  methods: {
    changedNetworkParams(params) {
      this.$emit('params-changed', params);
    },
  },
};
</script>
